import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import BubblesPage from "./components/Bubbles";
import DetailsPage from "./components/Details";
import FaqPage from "./components/ClassicFaq";
import ConditionsGeneralPage from "./components/ConditionsGeneral";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SearchPopup from "./components/SearchPopup"; 
import "./style/Bubbles.css";
import "./style/SearchPopup.css"; 
import MentionsLegales from "./components/MentionsLegales";

function App() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [viewMode, setViewMode] = useState("bubbles");
  const [query, setQuery] = useState("");
  const [cards, setCards] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;
  
  useEffect(() => {
    const fetchCards = async () => {
      try {
        const res = await axios.get(API_URL);
        setCards(res.data.Solutions[0].cards);
      } catch (err) {
        console.log(err);
      }
    };

    fetchCards();
  }, []);
  
  console.log(cards); 
  return (
    <Router>
      <div className="min-h-screen">
        <div className="bubbles-page">
          <Header 
            onSearchClick={() => setIsSearchOpen(true)}
            viewMode={viewMode}
            setViewMode={setViewMode}
          />
          <SearchPopup
            isOpen={isSearchOpen}
            query={query}         
            setQuery={setQuery}   
            onClose={() => {
              setIsSearchOpen(false);
              setQuery("");              
            }}
            cards={cards}
          />

          <Routes>
            <Route path="/" element={<BubblesPage cards={cards} viewMode={viewMode} setViewMode={setViewMode} />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/mentionslegales" element={<MentionsLegales />} />
            <Route path="/conditionsgeneral" element={<ConditionsGeneralPage />} />
            <Route path="/details/:id" element={<DetailsPage cards={cards} />} />
          </Routes>

          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
